module.exports = __webpack_public_path__ + "img/img-wrap2.0a23a09b.svg";